import TokenDetails from './TokenDetails.js';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

  
const Homepage = props => {
    const setCanvas = props.setCanvas;
    useEffect(()=>{
      setCanvas({enabled:true, display:"background", token:props.tokenList[0]});
    },[setCanvas, props.tokenList]);

    return (
      <>
      <motion.section 
        className="section main"
        initial={{opacity:0}}
        animate={{opacity:1}}
        transition={{duration:0.35, delay:0.5}}
      >
        <p className="is-size-1 is-size-4-mobile	">A limited edition of generative art inspired by early video synthesizers, permanently living on the blockchain.</p>
        <p className="is-size-7 mt-3">Sounds confusing? &rarr; <Link to="/about">Read more</Link></p>
      </motion.section>
      {props.tokenList[0] && (<TokenDetails token={props.tokenList[0]} blockchain={props.blockchain} />)}     
      </>
    )
  };
  
  export default Homepage;

